var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBarn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2146_13109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8637 10.4318L26.25 6.20455C25.8409 5.72727 25.3637 5.38636 24.8182 5.18182L16.5682 2.31818C15.5455 1.97727 14.4546 1.97727 13.4318 2.31818L5.25002 5.25C4.63639 5.45455 4.15911 5.79545 3.75002 6.27273L0.136387 10.5C-0.136341 10.7727 -0.0681589 11.25 0.204568 11.4545C0.340932 11.5227 0.545477 11.5909 0.681841 11.5909C0.886387 11.5909 1.09093 11.5227 1.2273 11.3864L4.84093 7.15909C5.04548 6.88636 5.38639 6.68182 5.72729 6.54545L13.9773 3.61364C14.6591 3.34091 15.4773 3.34091 16.1591 3.61364L24.4091 6.54545C24.75 6.68182 25.0227 6.88636 25.2955 7.15909L28.9091 11.3864C29.1818 11.6591 29.5909 11.7273 29.8637 11.4545C30.0682 11.1818 30.0682 10.7727 29.8637 10.4318Z",
    fill: "url(#paint0_linear_2146_13109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7273 12.9545C18.1364 12.9545 18.4091 12.6818 18.4091 12.2727V8.18182C18.4091 7.77273 18.1364 7.5 17.7273 7.5H12.2728C11.8637 7.5 11.5909 7.77273 11.5909 8.18182V12.2727C11.5909 12.6818 11.8637 12.9545 12.2728 12.9545H17.7273ZM12.9546 8.86364H17.0455V11.5909H12.9546V8.86364Z",
    fill: "url(#paint1_linear_2146_13109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6364 26.592H27.2728V11.592C27.2728 11.1829 27.0001 10.9102 26.591 10.9102C26.1819 10.9102 25.9092 11.1829 25.9092 11.592V26.592H23.1819V17.0465H23.8637C24.2728 17.0465 24.5455 16.7738 24.5455 16.3647C24.5455 15.9556 24.2728 15.6829 23.8637 15.6829H17.0455H12.9546H6.13643C5.72734 15.6829 5.45461 15.9556 5.45461 16.3647C5.45461 16.7738 5.72734 17.0465 6.13643 17.0465H6.81825V26.592H4.09098V11.592C4.09098 11.1829 3.81825 10.9102 3.40916 10.9102C3.00007 10.9102 2.72734 11.1829 2.72734 11.592V26.592H1.3637C0.954612 26.592 0.681885 26.8647 0.681885 27.2738C0.681885 27.6829 0.954612 27.9556 1.3637 27.9556H3.40916H7.50007H12.9546H17.0455H22.5001H26.591H28.6364C29.0455 27.9556 29.3182 27.6829 29.3182 27.2738C29.3182 26.8647 29.0455 26.592 28.6364 26.592ZM11.8637 17.0465L10.2273 20.3192L8.59098 17.0465H11.8637ZM8.18188 19.2283L9.47734 21.8192L8.18188 24.4102V19.2283ZM8.59098 26.592L10.2273 23.3192L11.8637 26.592H8.59098ZM12.2728 24.4102L10.9773 21.8192L12.2728 19.2283V24.4102ZM16.3637 26.592H13.6364V17.0465H16.3637V26.592ZM21.4092 17.0465L19.7728 20.3192L18.1364 17.0465H21.4092ZM17.7273 19.2283L19.0228 21.8192L17.7273 24.4102V19.2283ZM18.1364 26.592L19.7728 23.3192L21.4092 26.592H18.1364ZM21.8182 24.4102L20.5228 21.8192L21.8182 19.2283V24.4102Z",
    fill: "url(#paint2_linear_2146_13109)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2146_13109",
    x1: 14.9899,
    y1: 2.0625,
    x2: 14.9899,
    y2: 11.6282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2146_13109",
    x1: 15,
    y1: 7.5,
    x2: 15,
    y2: 12.9545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2146_13109",
    x1: 15.0001,
    y1: 10.9102,
    x2: 15.0001,
    y2: 27.9556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2146_13109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarn);
export default __webpack_public_path__ + "static/media/barn.614c2791.svg";
export { ForwardRef as ReactComponent };